function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import moment from 'moment';
import __ from 'ramda/src/__';
import clone from 'ramda/src/clone';
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import i18n from 'invision-core/src/components/i18n/i18n';
import { hasAccess } from 'invision-core/src/components/security/permission.service';
import { UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import { subscriberOrderTypeEnum } from 'invision-core/src/utilities/subscriber.order.type.enum';
import { fetchCodeTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { MetadataCodeLoadedSelector, MetadataCodeTypeSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { RouteParams } from 'invision-core/src/components/router/router.selectors';
import { retrieveOfferingsMetadata } from 'invision-core/src/components/metadata/offerings/offerings.actions';
import { CurrentCustomerIdSelector, CurrentCustomerSelector } from '../../../../../reducers/selectors/customer.selectors';
import { GetMaxDateForFutureDatedOrder, IsFutureDatedOrderAllowedInBunt } from '../../../../../reducers/selectors/selected.offering.order.selectors';
import { CandidateBillCyclesSelector, IsEvaluatingBillCyclesSelector } from '../../../../../reducers/selectors/customer.billcycle.selectors';
import { DASHBOARD_ROUTE } from '../../../../../reducers/constants/dashboard.constants';
import { retrieveCandidateBillCycles } from '../../../../../reducers/actions/customer.billcycle.actions';
import { retrieveConvergentBillerAccountDetails } from '../../../../../reducers/actions/customer.convergent.biller.actions';
import { asyncRepeatInterval, getRetrieveOrderQuoteCountdown } from '../../../../../reducers/helpers/async.helper';
import { clearDisconnect, disconnectSubscriber, disconnectSubscriberQuote, restoreDefaultEtf, retrieveOfferingRemovalContext, retrieveOrderContext, setDefaultEtfAmount, setWaiveAndReason, submitChangeOfServiceRemoval, toggleEtfWaive } from '../../../../../reducers/actions/offering.disconnect.actions';
import LocaleKeys from '../../../../../locales/keys';
import { BillingEffectiveDateOptionsSelector, BillingEffectiveDateSettingsSelector, ContractIdRouteParamSelector, DefaultEtfAmount, DisconnectAdhocQuoteItemsSelector, DisconnectItemsSelector, DisconnectOfferingServiceIdentifiersSelector, DisconnectOfferServiceFeaturesSelector, DisconnectOrderContractInstanceSelector, DisconnectQuoteSelector, EtfWaiveReason, HasDisconnectAdhocsSelector, HasFinancedDevicesSelector, HasProvidesPlansSelector, IsCalculatingQuoteSelector, IsDisconnectQuoteBypassedSelector, IsEtfWaived, IsFullDisconnect, IsRetrievingContextSelector, IsSubmittingOrderSelector, OfferGroupedQuoteItems, QuoteHasInvoiceItemsSelector, RemoveOfferItemsIdsSelector } from '../../../../../reducers/selectors/offering.disconnect.selectors';
import { FullCartOfferingOrderQuoteTotalSelector, FullCartOfferingOrderQuotesSelector, FullCartOfferingOrderFeeQuoteSelector, FullCartOfferingOrderTaxQuoteSelector, ShowHideFullCartColumnsSelector } from '../../../../../reducers/selectors/full.cart.selectors';
import { EARLY_TERMINATION_FEE_OVERRIDE_ACCESS } from '../../../../../security.attributes';
import { setReloadSubscriberStateFlag } from '../../../../../reducers/actions/customer.actions';
import { calculateChangeOfServiceOfferingOrderQuote, retrieveOfferingOrderQuote } from '../../../../../reducers/actions/offering.order.actions';
import { stateGo } from 'redux-ui-router';
import { DisconnectAndRemoveOfferCustomerReasonCodesSelector } from '../../../../../reducers/selectors/services.selectors';
import { REASON_CODES, RETRIEVE_ORDER_QUOTE_COUNTDOWN_DURATION } from '../../../../../customercare.constants';
import { AMOUNT_TYPES, getSummaryTotalsLabel } from '../../../../../reducers/helpers/summary.tab.helper';
import { IsAsyncCompleteSelector, IsQuoteBypassedSelector, IsQuotingOfferSelector, OfferingOrderAsyncIdSelector } from '../../../../../reducers/selectors/offering.order.selectors';
import { retrieveContractInstance } from '../../../../../reducers/actions/contract.details.actions';
var DisconnectOffersController = /*#__PURE__*/function () {
  function DisconnectOffersController($ngRedux, $state, $timeout, uiNotificationService) {
    _classCallCheck(this, DisconnectOffersController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $state: $state,
      $timeout: $timeout,
      AMOUNT_TYPES: AMOUNT_TYPES,
      CoreLocaleKeys: CoreLocaleKeys,
      closeViewFullCartPopupDialog: this.closeViewFullCartPopupDialog.bind(this),
      disconnectReasons: REASON_CODES,
      doErrorsExistOnFdoForm: this.doErrorsExistOnFdoForm.bind(this),
      errorsExistOnForm: true,
      executionOptionsMinDate: moment(this.getTomorrow()).startOf('day').utc().toISOString(),
      executionOptionsModel: {},
      formFieldConstraintParameters: {
        maxlength: {
          earlyTerminationFeeOverrideReason: 500
        }
      },
      getSummaryTotalsLabel: getSummaryTotalsLabel,
      getRetrieveOrderQuoteCountdown: getRetrieveOrderQuoteCountdown,
      handleOpenEditEtfPopup: this.handleOpenEditEtfPopup.bind(this),
      isDisconnecting: false,
      isLoading: false,
      LocaleKeys: LocaleKeys,
      onExecutionOptionChange: this.onExecutionOptionChange.bind(this),
      onOverrideCalculateQuote: this.onOverrideCalculateQuote.bind(this),
      openContractTermsConditionsPopup: this.openContractTermsConditionsPopup.bind(this),
      onRefreshQuote: this.onRefreshQuote.bind(this),
      overrideBypassQuoteConfiguration: false,
      calculateBypassedQuoteTotals: this.calculateBypassedQuoteTotals.bind(this),
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(DisconnectOffersController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var codeTables = [CODES.FutureDatedOrderConfiguration, CODES.ReasonCodes, CODES.RegularExpression, CODES.ServiceAttribute];
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          asyncId: OfferingOrderAsyncIdSelector(store),
          billingEffectiveDateOptions: BillingEffectiveDateOptionsSelector(store),
          billingEffectiveDateSettings: BillingEffectiveDateSettingsSelector(store),
          candidateBillCycles: CandidateBillCyclesSelector(store),
          codeTypeLoaded: MetadataCodeLoadedSelector(__, store),
          currentContractId: ContractIdRouteParamSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          currentCustomer: CurrentCustomerSelector(store),
          defaultEtfAmount: DefaultEtfAmount(store),
          disconnectAdhocQuoteItemsSelector: DisconnectAdhocQuoteItemsSelector(store),
          disconnectItems: DisconnectItemsSelector(store),
          // TODO Customer Order shouldn't SF item also be coming back from quote call, was informed that Full Disconnect not supported yet for SF
          disconnectOfferServiceFeatures: DisconnectOfferServiceFeaturesSelector(store),
          disconnectAndRemoveOfferCustomerReasons: DisconnectAndRemoveOfferCustomerReasonCodesSelector(store),
          etfWaive: IsEtfWaived(store),
          etfWaiveReason: EtfWaiveReason(store),
          fdoAllowedInBunt: IsFutureDatedOrderAllowedInBunt(store),
          fdoConfiguration: MetadataCodeTypeSelector(CODES.FutureDatedOrderConfiguration, store),
          fdoMaxDate: GetMaxDateForFutureDatedOrder(store),
          fullCartOfferingOrderQuotes: FullCartOfferingOrderQuotesSelector(store),
          fullCartOfferingOrderQuoteTotal: FullCartOfferingOrderQuoteTotalSelector(store),
          fullCartOfferingOrderFeeQuote: FullCartOfferingOrderFeeQuoteSelector(store),
          fullCartOfferingOrderTaxQuote: FullCartOfferingOrderTaxQuoteSelector(store),
          hasDisconnectAdhocsSelector: HasDisconnectAdhocsSelector(store),
          hasFinancedDevices: HasFinancedDevicesSelector(store),
          hasInvoiceItems: QuoteHasInvoiceItemsSelector(store),
          hasProvidesPlans: HasProvidesPlansSelector(store),
          isAsyncComplete: IsAsyncCompleteSelector(store),
          isCalculatingQuote: IsCalculatingQuoteSelector(store),
          isCalculatingCOSOfferingOrderQuote: IsQuotingOfferSelector(store),
          isDisconnectQuoteBypassed: IsDisconnectQuoteBypassedSelector(store),
          isEvaluatingBillCycles: IsEvaluatingBillCyclesSelector(store),
          isFullDisconnect: IsFullDisconnect(store),
          isRetrievingContext: IsRetrievingContextSelector(store),
          isSubmittingOrder: IsSubmittingOrderSelector(store),
          isRemoveOfferQuoteBypassed: IsQuoteBypassedSelector(store),
          offerGroupedQuoteItems: OfferGroupedQuoteItems(store),
          orderContractInstance: DisconnectOrderContractInstanceSelector(store),
          quoteOffer: DisconnectQuoteSelector(store),
          removeOfferItemsIds: RemoveOfferItemsIdsSelector(store),
          routeParams: RouteParams(store),
          serviceIdentifiers: DisconnectOfferingServiceIdentifiersSelector(store),
          showHideFullCartColumns: ShowHideFullCartColumnsSelector(store),
          userSecurityAttributes: UserSecurityAttributesSelector(store)
        };
      };
      var controllerActions = {
        calculateChangeOfServiceOfferingOrderQuote: calculateChangeOfServiceOfferingOrderQuote,
        clearDisconnect: clearDisconnect,
        disconnectSubscriber: disconnectSubscriber,
        disconnectSubscriberQuote: disconnectSubscriberQuote,
        fetchCodeTypes: fetchCodeTypes,
        restoreDefaultEtf: restoreDefaultEtf,
        retrieveCandidateBillCycles: retrieveCandidateBillCycles,
        retrieveContractInstance: retrieveContractInstance,
        retrieveConvergentBillerAccountDetails: retrieveConvergentBillerAccountDetails,
        retrieveOfferingOrderQuote: retrieveOfferingOrderQuote,
        retrieveOfferingRemovalContext: retrieveOfferingRemovalContext,
        retrieveOfferingsMetadata: retrieveOfferingsMetadata,
        retrieveOrderContext: retrieveOrderContext,
        setDefaultEtfAmount: setDefaultEtfAmount,
        setReloadSubscriberStateFlag: setReloadSubscriberStateFlag,
        setWaiveAndReason: setWaiveAndReason,
        stateGo: stateGo,
        submitChangeOfServiceRemoval: submitChangeOfServiceRemoval,
        toggleEtfWaive: toggleEtfWaive
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        Object.assign(_this, {
          state: state,
          actions: actions
        });
      });
      if (!this.state.isFullDisconnect) {
        this.actions.retrieveOfferingsMetadata([this.state.routeParams.offeringId]).catch(function (error) {
          _this.uiNotificationService.transientError(error.translatedMessage);
        });
      }
      this.actions.retrieveOrderContext(this.state.currentCustomerId).catch(function (error) {
        _this.uiNotificationService.transientError(error.translatedMessage);
      });
      this.retrieveBillCycleDetails();
      this.state.isFullDisconnect ? this.disconnectQuote() : this.retrieveOfferingRemovalDetails();
      this.disconnectOfferConfirmationPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this.disconnectOfferConfirmationPopupApi = api;
        }
      };
      this.editEtfPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref2) {
          var api = _ref2.api;
          _this.editEtfPopupApi = api;
        }
      };
      this.viewFullCartPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this.viewFullCartPopupApi = event.api;
        }
      };
      this.contractTermsConditionsPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref3) {
          var api = _ref3.api;
          _this.contractTermsConditionsPopupApi = api;
        }
      };
      codeTables.forEach(function (codeType) {
        if (!_this.state.codeTypeLoaded(codeType)) {
          _this.actions.fetchCodeTypes(codeType).catch(function (error) {
            _this.uiNotificationService.transientError(error.translatedMessage);
          });
        }
      });
    }
  }, {
    key: "onOverrideCalculateQuote",
    value: function onOverrideCalculateQuote() {
      this.overrideBypassQuoteConfiguration = true;
      this.actions.calculateChangeOfServiceOfferingOrderQuote(this.state.currentCustomer, undefined, undefined, this.getDisconnectItemsWithBedAndFinanceDetails(), undefined, this.executionOptionsModel, undefined, undefined, undefined, this.overrideBypassQuoteConfiguration);
    }
  }, {
    key: "onViewFullCartRequest",
    value: function onViewFullCartRequest() {
      var _this2 = this;
      Promise.resolve().then(function () {
        if (!Object.keys(_this2.state.quoteOffer).length) {
          _this2.isLoading = true;
          return _this2.actions.calculateChangeOfServiceOfferingOrderQuote(_this2.state.currentCustomer, null, null, _this2.getDisconnectItemsWithBedAndFinanceDetails(), undefined, _this2.executionOptionsModel, undefined, undefined, undefined, _this2.overrideBypassQuoteConfiguration);
        }
      }).then(function () {
        _this2.isLoading = false;
        _this2.$timeout(_this2.openViewFullCartPopupDialog.bind(_this2));
      }).catch(function (error) {
        _this2.isLoading = false;
        _this2.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "gotoDecisionsPage",
    value: function gotoDecisionsPage() {
      this.closeViewFullCartPopupDialog();
      this.actions.goToStep(LocaleKeys.WIZARD.STEPS.DECISIONS);
    }
  }, {
    key: "openViewFullCartPopupDialog",
    value: function openViewFullCartPopupDialog() {
      this.showViewFullCartPopup = true;
      this.$timeout(this.viewFullCartPopupApi.open);
    }
  }, {
    key: "closeViewFullCartPopupDialog",
    value: function closeViewFullCartPopupDialog() {
      this.showViewFullCartPopup = false;
      this.viewFullCartPopupApi.close();
    }
  }, {
    key: "handleOpenEditEtfPopup",
    value: function handleOpenEditEtfPopup() {
      this.overrideEtfModel = clone(this.state.orderContractInstance);
      this.editEtfPopupApi.open();
    }
  }, {
    key: "handleSubmitButton",
    value: function handleSubmitButton() {
      this.disconnectOfferConfirmationPopupApi.open();
    }
  }, {
    key: "handleCancelRoute",
    value: function handleCancelRoute() {
      this.$state.go(DASHBOARD_ROUTE);
    }
  }, {
    key: "handleCloseDisconnectOfferConfirmationPopupCancel",
    value: function handleCloseDisconnectOfferConfirmationPopupCancel() {
      this.disconnectOfferConfirmationPopupApi.close();
    }
  }, {
    key: "handleCloseEditEtfPopupCancel",
    value: function handleCloseEditEtfPopupCancel() {
      this.editEtfPopupApi.close();
    }
  }, {
    key: "openContractTermsConditionsPopup",
    value: function openContractTermsConditionsPopup() {
      var _this3 = this;
      this.contractTermsConditionsPopupOpened = true;
      this.$timeout(function () {
        _this3.contractTermsConditionsPopupApi.open();
      });
    }
  }, {
    key: "handleCloseContractTermsConditionsPopup",
    value: function handleCloseContractTermsConditionsPopup() {
      this.contractTermsConditionsPopupApi.close();
      this.contractTermsConditionsPopupOpened = false;
    }
  }, {
    key: "hasEarlyTerminationFeeOverrideAccess",
    value: function hasEarlyTerminationFeeOverrideAccess() {
      return hasAccess(this.state.userSecurityAttributes, EARLY_TERMINATION_FEE_OVERRIDE_ACCESS);
    }

    //Calls retrieveOrderQuote the first time and then calls it every 30 seconds that the call hasnt returned a response
  }, {
    key: "repeatRetrieveQuote",
    value: function repeatRetrieveQuote() {
      var _this4 = this;
      asyncRepeatInterval(this.onRefreshQuote, function () {
        return !_this4.state.isAsyncComplete;
      });
    }
  }, {
    key: "onRefreshQuote",
    value: function onRefreshQuote() {
      var _this5 = this;
      return this.actions.retrieveOfferingOrderQuote(this.state.currentCustomerId, this.state.asyncId).then(function (response) {
        _this5.retrieveOrderQuoteTimestamp = moment().add(RETRIEVE_ORDER_QUOTE_COUNTDOWN_DURATION, 'milliseconds');
        return response;
      }).catch(function (error) {
        return _this5.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "restoreEarlyTerminationFee",
    value: function restoreEarlyTerminationFee() {
      var _this6 = this;
      this.actions.restoreDefaultEtf();
      if (this.state.isFullDisconnect) {
        this.actions.disconnectSubscriberQuote(this.state.currentCustomerId, undefined, undefined, undefined, this.overrideBypassQuoteConfiguration).catch(function (error) {
          _this6.uiNotificationService.transientError(error.translatedMessage);
        });
      } else {
        this.actions.calculateChangeOfServiceOfferingOrderQuote(this.state.currentCustomer, undefined, undefined, this.getDisconnectItemsWithBedAndFinanceDetails(), undefined, this.executionOptionsModel, false, undefined, undefined, this.overrideBypassQuoteConfiguration).catch(function (error) {
          _this6.uiNotificationService.transientError(error.translatedMessage);
        });
      }
      this.editEtfPopupApi.close();
    }
  }, {
    key: "updateEarlyTerminationFee",
    value: function updateEarlyTerminationFee() {
      var _this7 = this;
      this.actions.setWaiveAndReason(this.overrideEtfModel.earlyTerminationFeeOverrideReason);
      this.state.isFullDisconnect ? this.actions.disconnectSubscriberQuote(this.state.currentCustomerId, this.state.etfWaive, this.overrideEtfModel.earlyTerminationFeeOverrideReason, undefined, this.overrideBypassQuoteConfiguration).catch(function (error) {
        _this7.uiNotificationService.transientError(error.translatedMessage);
      }) : this.actions.calculateChangeOfServiceOfferingOrderQuote(this.state.currentCustomer, undefined, undefined, this.getDisconnectItemsWithBedAndFinanceDetails(), undefined, this.executionOptionsModel, false, undefined, undefined, this.overrideBypassQuoteConfiguration).catch(function (error) {
        _this7.uiNotificationService.transientError(error.translatedMessage);
      });
      this.editEtfPopupApi.close();
    }
  }, {
    key: "retrieveBillCycleDetails",
    value: function retrieveBillCycleDetails() {
      var _this8 = this;
      this.actions.retrieveCandidateBillCycles(this.state.currentCustomerId, subscriberOrderTypeEnum.postpaid.value).then(function () {
        _this8.selectedBillCycle = _this8.state.candidateBillCycles && _this8.state.candidateBillCycles.length ? _this8.state.candidateBillCycles.find(function (billCycle) {
          return billCycle.id === _this8.state.currentCustomer.SubscriberTypeDetails.BillCycle;
        }) : null;
      }).catch(function (error) {
        _this8.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "retrieveOfferingRemovalDetails",
    value: function retrieveOfferingRemovalDetails() {
      var _this9 = this;
      this.actions.retrieveOfferingRemovalContext(this.state.removeOfferItemsIds, this.state.currentCustomerId, this.state.currentContractId).then(function () {
        _this9.actions.calculateChangeOfServiceOfferingOrderQuote(_this9.state.currentCustomer, undefined, undefined, _this9.getDisconnectItemsWithBedAndFinanceDetails(), undefined, _this9.executionOptionsModel, false, undefined, undefined, _this9.overrideBypassQuoteConfiguration).then(function () {
          _this9.actions.setDefaultEtfAmount(_this9.state.quoteOffer.EarlyTerminationFeeAmount);
          if (_this9.state.asyncId) {
            _this9.repeatRetrieveQuote();
          }
          if (_this9.state.orderContractInstance && _this9.state.orderContractInstance.orderContractInstanceId && _this9.state.orderContractInstance.orderContractInstanceId !== '0') {
            return _this9.actions.retrieveContractInstance(+_this9.state.orderContractInstance.orderContractInstanceId, _this9.state.currentCustomer.Id);
          }
        }).catch(function (error) {
          _this9.uiNotificationService.transientError(error.translatedMessage);
        });
      }).catch(function (error) {
        _this9.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "disconnectQuote",
    value: function disconnectQuote() {
      var _this10 = this;
      this.actions.disconnectSubscriberQuote(this.state.currentCustomerId, false, null, this.executionOptionsModel.disconnectReason, this.overrideBypassQuoteConfiguration).then(function (response) {
        if (response.Quote) {
          _this10.actions.setDefaultEtfAmount(response.Quote.Totals.EarlyTerminationFeeAmount);
        }
      }).catch(function (error) {
        _this10.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "calculateBypassedQuoteTotals",
    value: function calculateBypassedQuoteTotals() {
      this.overrideBypassQuoteConfiguration = true;
      this.disconnectQuote();
    }
  }, {
    key: "handleResultDisconnectOfferConfirmationPopup",
    value: function handleResultDisconnectOfferConfirmationPopup(confirmed) {
      if (confirmed && !this.isDisconnecting && !this.errorsExistOnForm) {
        this.state.isFullDisconnect ? this.fullDisconnect() : this.disconnectSingleOffer();
      }
      this.handleCloseDisconnectOfferConfirmationPopupCancel();
    }
  }, {
    key: "getDisconnectItemsWithBedAndFinanceDetails",
    value: function getDisconnectItemsWithBedAndFinanceDetails() {
      var _this11 = this;
      return (this.state.disconnectItems || []).map(function (itemToRemove) {
        var _this11$executionOpti;
        return Object.assign({}, itemToRemove, _objectSpread(_objectSpread(_objectSpread({}, _this11.state.hasFinancedDevices && _this11.executionOptionsModel.applyBalanceToInvoice !== null && {
          FinanceDetails: itemToRemove.FinanceDetails ? Object.assign({}, itemToRemove.FinanceDetails, {
            ApplyBalanceToInvoice: _this11.executionOptionsModel.applyBalanceToInvoice
          }) : undefined
        }), ((_this11$executionOpti = _this11.executionOptionsModel) === null || _this11$executionOpti === void 0 ? void 0 : _this11$executionOpti.billingEffectiveIntention) && {
          BillingEffectiveDateIntention: _this11.executionOptionsModel.billingEffectiveIntention
        }), _this11.executionOptionsModel.billingEffectiveDate && {
          BillingEffectiveDate: _this11.executionOptionsModel.billingEffectiveDate
        }));
      });
    }
  }, {
    key: "disconnectSingleOffer",
    value: function disconnectSingleOffer() {
      var _this12 = this;
      this.isDisconnecting = true;
      var disconnectItems = this.getDisconnectItemsWithBedAndFinanceDetails();
      this.actions.submitChangeOfServiceRemoval(disconnectItems, this.state.currentCustomerId, this.executionOptionsModel).then(function () {
        /*
        * TODO:
        * PD-411357
        * Need to identify when the subscriber has no more offers left to trigger (Switches to disconnect state) below action
        */
        _this12.actions.setReloadSubscriberStateFlag(true);
        _this12.uiNotificationService.transientSuccess(i18n.translate(_this12.LocaleKeys.DISCONNECT_OFFERS.DISCONNECT_SUCCESSFUL));
        _this12.transitionToDashboard();
      }).catch(function (error) {
        _this12.uiNotificationService.transientError(error.translatedMessage);
      }).finally(function () {
        _this12.isDisconnecting = false;
      });
    }
  }, {
    key: "fullDisconnect",
    value: function fullDisconnect() {
      var _this13 = this;
      this.isDisconnecting = true;
      this.actions.disconnectSubscriber(this.state.currentCustomerId, this.executionOptionsModel, this.state.etfWaive, this.state.etfWaiveReason).then(function () {
        _this13.actions.setReloadSubscriberStateFlag(true);
        _this13.uiNotificationService.transientSuccess(i18n.translate(_this13.LocaleKeys.DISCONNECT_OFFERS.DISCONNECT_SUCCESSFUL));
        _this13.transitionToDashboard();
      }).catch(function (error) {
        _this13.uiNotificationService.transientError(error.translatedMessage);
      }).finally(function () {
        _this13.isDisconnecting = false;
      });
    }
  }, {
    key: "transitionToDashboard",
    value: function transitionToDashboard() {
      var subscriberId = this.state.currentCustomerId;
      var params = {
        customerId: subscriberId
      };
      var options = {
        reload: true
      };
      this.actions.stateGo(DASHBOARD_ROUTE, params, options);
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.actions.clearDisconnect();
      this.disconnectRedux();
    }
  }, {
    key: "getTomorrow",
    value: function getTomorrow() {
      var today = moment();
      return moment(today).add(1, 'days');
    }
  }, {
    key: "onExecutionOptionChange",
    value: function onExecutionOptionChange(model, isCreditCheckFinancingChange, isReasonChange) {
      var _this14 = this;
      this.executionOptionsModel = model;
      if (isCreditCheckFinancingChange || isReasonChange) {
        if (this.state.isFullDisconnect) {
          this.disconnectQuote();
        } else {
          var disconnectItems = this.state.hasFinancedDevices && this.executionOptionsModel.applyBalanceToInvoice !== null ? this.state.disconnectItems.map(function (itemToRemove) {
            var _this14$executionOpti;
            return Object.assign({}, itemToRemove, _objectSpread(_objectSpread({
              FinanceDetails: itemToRemove.FinanceDetails ? Object.assign({}, itemToRemove.FinanceDetails, {
                ApplyBalanceToInvoice: _this14.executionOptionsModel.applyBalanceToInvoice
              }) : undefined
            }, ((_this14$executionOpti = _this14.executionOptionsModel) === null || _this14$executionOpti === void 0 ? void 0 : _this14$executionOpti.billingEffectiveIntention) && {
              BillingEffectiveDateIntention: _this14.executionOptionsModel.billingEffectiveIntention
            }), _this14.executionOptionsModel.billingEffectiveDate && {
              BillingEffectiveDate: _this14.executionOptionsModel.billingEffectiveDate
            }));
          }) : this.getDisconnectItemsWithBedAndFinanceDetails();
          this.actions.calculateChangeOfServiceOfferingOrderQuote(this.state.currentCustomer, undefined, undefined, disconnectItems, undefined, this.executionOptionsModel, false, undefined, undefined, this.overrideBypassQuoteConfiguration).catch(function (error) {
            _this14.uiNotificationService.transientError(error.translatedMessage);
          });
        }
      }
    }
  }, {
    key: "doErrorsExistOnFdoForm",
    value: function doErrorsExistOnFdoForm(isFormValid) {
      this.errorsExistOnForm = isFormValid;
    }
  }, {
    key: "headingText",
    value: function headingText() {
      return i18n.translate(this.state.isFullDisconnect ? this.LocaleKeys.DISCONNECT_OFFERS.DISCONNECT_CUSTOMER : this.LocaleKeys.DISCONNECT_OFFERS.REMOVE_OFFER);
    }
  }]);
}();
export default {
  template: require('./disconnect.offers.dbss.html'),
  bindings: {},
  controller: DisconnectOffersController,
  controllerAs: 'DisconnectOffers'
};